import React, { useState } from 'react';
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from 'reactstrap';
import classnames from 'classnames';

import Wrapper from '../../components/Wrapper';
import Section from '../../components/Section';
import Table from '../../components/Table';

function Home() {
  const [activeTab, setActiveTab] = useState(1);

  return (
    <div>
      <Wrapper>
        <Section className='hps-section' title='HPS mini GP poredak'>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 1 })}
                onClick={() => setActiveTab(1)}
              >
                PLIVAČICE
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 2 })}
                onClick={() => setActiveTab(2)}
              >
                PLIVAČI
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            <TabPane tabId={1}>
              <Row>
                <Col sm='12'>
                  <Table spol='Z' />
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={2}>
              <Row>
                <Col sm='12'>
                  <Table spol='M' />
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </Section>
      </Wrapper>
    </div>
  );
}

export default Home;
